unit UCustomerSelect;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, DB, WEBLib.Grids, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Controls, WEBLib.WebCtrls, XData.Web.Client;

type
  TfrmCustomerSelect = class(TForm)
    divCustomerSelectOuterContainer: THTMLDiv;
    divCustomerSelectMainContainer: THTMLDiv;
    btnAccept: TButton;
    tblCustomerAll: TTableControl;
    tblCustomerUser: TTableControl;
    lblDirty: TLabel;
    WebLabel1: TLabel;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure tblCustomerAllClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure tblCustomerUserClickCell(Sender: TObject; ACol, ARow: Integer);
    [async] procedure btnAcceptClick(Sender: TObject); async;
  private
    FWaiting : Boolean;
    FUser: TJSObject;
    FCustomerArray : TJSArray;
    procedure FillTables;
    [async] procedure LoadCustomerArray; async;
    procedure FillCustomerUserTable;
    procedure FillCustomerAllTable;
    procedure ShowHeaders;
    procedure SetUser(const Value: TJSObject);
  public
    [async] procedure UpdateCustomer; async;
    property User : TJSObject read FUser write SetUser;
  protected procedure LoadDFMValues; override; end;

var
  frmCustomerSelect: TfrmCustomerSelect;

implementation

uses
  UErrorHandling, UDatamodule, UHelper, UUser, System.TypInfo;

{$R *.dfm}

procedure TfrmCustomerSelect.btnAcceptClick(Sender: TObject);
var
  lForm : TfrmUser;
begin
  FWaiting := true;

  asm
    await this.UpdateCustomer();
  end;


  if Assigned(lForm) then
  begin
    lForm.Close;
  end;
  lForm := TfrmUser.CreateNew(divCustomerSelectOuterContainer.ElementID, nil);
  lForm.UserID := Integer(FUser.Properties['UserID']);
end;


procedure TfrmCustomerSelect.FillCustomerAllTable;
var
  Idx : Integer;
  I : Integer;
  Kunde : TJSObject;
  UCustomers : TJSArray;
  Customer : TJSObject;
  Found : Boolean;
  J: Integer;
begin
  tblCustomerAll.RowCount := FCustomerArray.Length + 1;

  Idx := 1;

  for I := 0 to FCustomerArray.Length - 1 do
  begin
    Kunde := TJsObject(FCustomerArray.Elements[I]);
    THelper.DebugODS(String(Kunde.Properties['UserName']));

    Found := false;

    UCustomers := TJSArray(FUser.Properties['Kunden']);

    if Assigned(UCustomers) then
    begin
      for J := 0 to UCustomers.Length - 1 do
      begin
        Customer := TJSObject(UCustomers.Elements[J]);
        if Integer(Customer.Properties['ID']) = Integer(Kunde.Properties['ID']) then
        begin
          Found := true;
          break;
        end;

      end;
    end;

    if not Found then
    begin
      tblCustomerAll.Cells[0, Idx] := String(Kunde.Properties['Anzeigename']);
      tblCustomerAll.Cells[1, Idx] := String(Kunde.Properties['Name']);
      tblCustomerAll.Cells[2, Idx] := String(Kunde.Properties['Kontonummer']);
      Inc(Idx);
    end;
  end;
  tblCustomerAll.RowCount := Idx;
end;


procedure TfrmCustomerSelect.FillCustomerUserTable;
var
  Customers : TJSArray;
  Customer : TJSObject;
  Idx : Integer;
  I : Integer;
begin
  Customers := TJSArray(FUser.Properties['Kunden']);

  Idx := 1;

  if Assigned(Customers) then
  begin
    tblCustomerUser.RowCount := Customers.Length + 1;

    for I := 0 to Customers.Length - 1 do
    begin
      Customer := TJSObject(Customers.Elements[I]);
      tblCustomerUser.Cells[0, Idx] := String(Customer.Properties['Anzeigename']);
      tblCustomerUser.Cells[1, Idx] := String(Customer.Properties['Name']);
      tblCustomerUser.Cells[2, Idx] := String(Customer.Properties['Kontonummer']);
      Inc(Idx);
    end;
  end;

  tblCustomerUser.RowCount := idx;
end;


procedure TfrmCustomerSelect.FillTables;
begin
  FillCustomerUserTable;
  FillCustomerAllTable;
end;


procedure TfrmCustomerSelect.LoadCustomerArray;
var
  LResponse: TXDataClientResponse;
  JSObject : TJsObject;
begin
  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('IKunden.GetkundenListe',
        [])
      );

    if LResponse.StatusCode = 200 then
    begin
      THelper.DebugODS('Received customer list');
      JSObject := LResponse.ResultAsObject;
      FCustomerArray := TJSArray(JSObject['value']);

    end
    else
    begin
      MessageDlg('Customer list not received. Status: ' + IntToStr(LResponse.StatusCode), mtInformation, [mbOk]);
    end;
  except
    on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;

  FillTables;
end;


procedure TfrmCustomerSelect.SetUser(const Value: TJSObject);
begin
  FUser := Value;
end;


procedure TfrmCustomerSelect.SHowHeaders;
begin
  tblCustomerAll.Cells[0,0] := 'Anzeigename';
  tblCustomerAll.Cells[1,0] := 'Name';
  tblCustomerAll.Cells[2,0] := 'Kontonummer';
  tblCustomerAll.RowCount := 1;

  tblCustomerUser.Cells[0,0] := 'Anzeigename';
  tblCustomerUser.Cells[1,0] := 'Name';
  tblCustomerUser.Cells[2,0] := 'Kontonummer';
  tblCustomerUser.RowCount := 1;
end;


procedure TfrmCustomerSelect.tblCustomerAllClickCell(Sender: TObject; ACol,
  ARow: Integer);
var
  ID : Integer;
  Customer : TJSObject;
  I: Integer;
  UserCustomers : TJSArray;
  Found : Boolean;
begin
  ID := StrToInt(tblCustomerAll.Cells[0, ARow]);
  Found := false;
  for I := 0 to FCustomerArray.Length - 1 do
  begin
    Customer := TJSObject(FCustomerArray.Elements[I]);
    if Integer(Customer.Properties['ID']) = ID then
    begin
      Found := true;
      break;
    end;
  end;

  if Found then
  begin
    UserCustomers := TJSArray(FUser.Properties['Kunden']);
    UserCustomers.push(Customer);
  end;

  FillTables;
end;


procedure TfrmCustomerSelect.tblCustomerUserClickCell(Sender: TObject; ACol,
  ARow: Integer);
var
  ID : Integer;
  Idx : Integer;
  UserCustomers : TJSArray;
  Customer : TJSObject;
  I: Integer;
begin
  ID := StrToInt(tblCustomerUser.Cells[0, ARow]);

  UserCustomers := TJSArray(FUser.Properties['Kunden']);

  Idx := -1;

  for I := 0 to UserCustomers.Length - 1 do
  begin
    Customer := TJSObject(UserCustomers.Elements[I]);

    if Integer(Customer.Properties['ID']) = ID then
    begin
      Idx := I;
      break;
    end;
  end;

  if (Idx >= 0) then
  begin
    UserCustomers.splice(Idx, 1);
  end;

  FillTables;
end;

procedure TfrmCustomerSelect.UpdateCustomer;
var
  LResponse: TXDataClientResponse;
  UserID : Integer;
  CustomerList : TJsObject;
begin
  UserId := Integer(FUser.Properties['UserID']);
  if (UserID < 0) then
  begin
    // Neuer Benutzer!
    FWaiting := false;
    Exit;
  end;

  try
    CustomerList := TJSObject(FUser.Properties['Kunden']);
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('IUsers.SetCustomer',
        [UserID, CustomerList])
      );

    FWaiting := false;

    if LResponse.StatusCode = 204 then
    begin
      THelper.DebugODS('Updated CustomerList');
    end
    else
    begin
      MessageDlg('Customer list not updated. Status: ' + IntToStr(LResponse.StatusCode), mtInformation, [mbOk]);
    end;
  except
    on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;

end;


procedure TfrmCustomerSelect.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  Action := TCloseAction.caFree;
end;


procedure TfrmCustomerSelect.WebFormCreate(Sender: TObject);
begin
  ShowHeaders;
end;


procedure TfrmCustomerSelect.WebFormShow(Sender: TObject);
begin
  {$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.UserInit();
    pas.UJSHelper.THTMLComponents.CheckLanguage();
    pas.UJSHelper.THTMLComponents.SetEvents();
  end;
  {$ENDIF}
  LoadCustomerArray;
end;

procedure TfrmCustomerSelect.LoadDFMValues;
begin
  inherited LoadDFMValues;

  divCustomerSelectOuterContainer := THTMLDiv.Create('wcIDCustomerSelectOuterContainer');
  divCustomerSelectMainContainer := THTMLDiv.Create('wcIDCustomerSelectMainContainer');
  lblDirty := TLabel.Create('wcIDCustomerUser');
  WebLabel1 := TLabel.Create('wcIDCustomerAll');
  btnAccept := TButton.Create('wcIDSaveBtn');
  tblCustomerAll := TTableControl.Create('wcIDCustomerAllTbl');
  tblCustomerUser := TTableControl.Create('wcIDCustomerUserTbl');

  divCustomerSelectOuterContainer.BeforeLoadDFMValues;
  divCustomerSelectMainContainer.BeforeLoadDFMValues;
  lblDirty.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  btnAccept.BeforeLoadDFMValues;
  tblCustomerAll.BeforeLoadDFMValues;
  tblCustomerUser.BeforeLoadDFMValues;
  try
    Name := 'frmCustomerSelect';
    Width := 1098;
    Height := 866;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    divCustomerSelectOuterContainer.SetParentComponent(Self);
    divCustomerSelectOuterContainer.Name := 'divCustomerSelectOuterContainer';
    divCustomerSelectOuterContainer.Left := 0;
    divCustomerSelectOuterContainer.Top := 0;
    divCustomerSelectOuterContainer.Width := 1098;
    divCustomerSelectOuterContainer.Height := 866;
    divCustomerSelectOuterContainer.HeightStyle := ssAuto;
    divCustomerSelectOuterContainer.WidthStyle := ssAuto;
    divCustomerSelectOuterContainer.Align := alClient;
    divCustomerSelectOuterContainer.ChildOrder := 2;
    divCustomerSelectOuterContainer.ElementPosition := epIgnore;
    divCustomerSelectOuterContainer.ElementFont := efCSS;
    divCustomerSelectOuterContainer.Role := '';
    divCustomerSelectMainContainer.SetParentComponent(divCustomerSelectOuterContainer);
    divCustomerSelectMainContainer.Name := 'divCustomerSelectMainContainer';
    divCustomerSelectMainContainer.Left := 0;
    divCustomerSelectMainContainer.Top := 0;
    divCustomerSelectMainContainer.Width := 1098;
    divCustomerSelectMainContainer.Height := 866;
    divCustomerSelectMainContainer.ElementClassName := 'wcCLMainContainer Container';
    divCustomerSelectMainContainer.HeightStyle := ssAuto;
    divCustomerSelectMainContainer.WidthStyle := ssAuto;
    divCustomerSelectMainContainer.Align := alClient;
    divCustomerSelectMainContainer.ElementPosition := epIgnore;
    divCustomerSelectMainContainer.ElementFont := efCSS;
    divCustomerSelectMainContainer.Role := '';
    lblDirty.SetParentComponent(divCustomerSelectMainContainer);
    lblDirty.Name := 'lblDirty';
    lblDirty.Left := 133;
    lblDirty.Top := 439;
    lblDirty.Width := 156;
    lblDirty.Height := 35;
    lblDirty.Caption := 'Zugeordnet:';
    lblDirty.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLUserLbl';
    lblDirty.ElementFont := efCSS;
    lblDirty.ElementPosition := epIgnore;
    lblDirty.Font.Charset := DEFAULT_CHARSET;
    lblDirty.Font.Color := clWindowText;
    lblDirty.Font.Height := -29;
    lblDirty.Font.Name := 'Tahoma';
    lblDirty.Font.Style := [];
    lblDirty.HeightStyle := ssAuto;
    lblDirty.HeightPercent := 100.000000000000000000;
    lblDirty.ParentFont := False;
    lblDirty.WidthStyle := ssAuto;
    lblDirty.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(divCustomerSelectMainContainer);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 133;
    WebLabel1.Top := 16;
    WebLabel1.Width := 154;
    WebLabel1.Height := 35;
    WebLabel1.Caption := 'Hinzuf'#252'gen:';
    WebLabel1.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLUserLbl';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.ElementPosition := epIgnore;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -29;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthStyle := ssAuto;
    WebLabel1.WidthPercent := 100.000000000000000000;
    btnAccept.SetParentComponent(divCustomerSelectMainContainer);
    btnAccept.Name := 'btnAccept';
    btnAccept.Left := 401;
    btnAccept.Top := 783;
    btnAccept.Width := 145;
    btnAccept.Height := 50;
    btnAccept.Caption := #220'bernehmen';
    btnAccept.ChildOrder := 1;
    btnAccept.ElementClassName := 'btn btn-primary wcCLNewUserBtn';
    btnAccept.ElementFont := efCSS;
    btnAccept.ElementPosition := epIgnore;
    btnAccept.Font.Charset := DEFAULT_CHARSET;
    btnAccept.Font.Color := clWindowText;
    btnAccept.Font.Height := -19;
    btnAccept.Font.Name := 'Tahoma';
    btnAccept.Font.Style := [];
    btnAccept.HeightStyle := ssAuto;
    btnAccept.HeightPercent := 100.000000000000000000;
    btnAccept.ParentFont := False;
    btnAccept.TabOrder := 9;
    btnAccept.WidthStyle := ssAuto;
    btnAccept.WidthPercent := 100.000000000000000000;
    SetEvent(btnAccept, Self, 'OnClick', 'btnAcceptClick');
    tblCustomerAll.SetParentComponent(divCustomerSelectMainContainer);
    tblCustomerAll.Name := 'tblCustomerAll';
    tblCustomerAll.Left := 133;
    tblCustomerAll.Top := 66;
    tblCustomerAll.Width := 705;
    tblCustomerAll.Height := 303;
    tblCustomerAll.ElementClassName := 'display wcCLTableUsers';
    tblCustomerAll.HeightStyle := ssAuto;
    tblCustomerAll.WidthStyle := ssAuto;
    tblCustomerAll.BorderColor := clSilver;
    tblCustomerAll.ChildOrder := 1;
    tblCustomerAll.ElementFont := efCSS;
    tblCustomerAll.ElementHeaderClassName := 'thead-light';
    tblCustomerAll.ElementPosition := epIgnore;
    tblCustomerAll.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    tblCustomerAll.Font.Charset := DEFAULT_CHARSET;
    tblCustomerAll.Font.Color := clWindowText;
    tblCustomerAll.Font.Height := -16;
    tblCustomerAll.Font.Name := 'Tahoma';
    tblCustomerAll.Font.Style := [];
    tblCustomerAll.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    tblCustomerAll.Footer.ButtonElementClassName := 'btn btn-light';
    tblCustomerAll.Footer.DropDownElementClassName := 'form-control';
    tblCustomerAll.Footer.InputElementClassName := 'form-control';
    tblCustomerAll.Footer.LinkActiveElementClassName := 'link-primary';
    tblCustomerAll.Footer.LinkElementClassName := 'link-secondary';
    tblCustomerAll.Footer.ListElementClassName := 'pagination';
    tblCustomerAll.Footer.ListItemElementClassName := 'page-item';
    tblCustomerAll.Footer.ListLinkElementClassName := 'page-link';
    tblCustomerAll.Header.ButtonActiveElementClassName := 'btn btn-primary';
    tblCustomerAll.Header.ButtonElementClassName := 'btn btn-light';
    tblCustomerAll.Header.DropDownElementClassName := 'form-control';
    tblCustomerAll.Header.InputElementClassName := 'form-control';
    tblCustomerAll.Header.LinkActiveElementClassName := 'link-primary';
    tblCustomerAll.Header.LinkElementClassName := 'link-secondary';
    tblCustomerAll.Header.ListElementClassName := 'pagination';
    tblCustomerAll.Header.ListItemElementClassName := 'page-item';
    tblCustomerAll.Header.ListLinkElementClassName := 'page-link';
    tblCustomerAll.ParentFont := False;
    tblCustomerAll.WordWrap := True;
    SetEvent(tblCustomerAll, Self, 'OnClickCell', 'tblCustomerAllClickCell');
    tblCustomerAll.ColCount := 3;
    tblCustomerUser.SetParentComponent(divCustomerSelectMainContainer);
    tblCustomerUser.Name := 'tblCustomerUser';
    tblCustomerUser.Left := 133;
    tblCustomerUser.Top := 480;
    tblCustomerUser.Width := 705;
    tblCustomerUser.Height := 225;
    tblCustomerUser.ElementClassName := 'display wcCLTableUsers';
    tblCustomerUser.HeightStyle := ssAuto;
    tblCustomerUser.WidthStyle := ssAuto;
    tblCustomerUser.BorderColor := clSilver;
    tblCustomerUser.ChildOrder := 1;
    tblCustomerUser.ElementFont := efCSS;
    tblCustomerUser.ElementHeaderClassName := 'thead-light';
    tblCustomerUser.ElementPosition := epIgnore;
    tblCustomerUser.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    tblCustomerUser.Font.Charset := DEFAULT_CHARSET;
    tblCustomerUser.Font.Color := clWindowText;
    tblCustomerUser.Font.Height := -16;
    tblCustomerUser.Font.Name := 'Tahoma';
    tblCustomerUser.Font.Style := [];
    tblCustomerUser.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    tblCustomerUser.Footer.ButtonElementClassName := 'btn btn-light';
    tblCustomerUser.Footer.DropDownElementClassName := 'form-control';
    tblCustomerUser.Footer.InputElementClassName := 'form-control';
    tblCustomerUser.Footer.LinkActiveElementClassName := 'link-primary';
    tblCustomerUser.Footer.LinkElementClassName := 'link-secondary';
    tblCustomerUser.Footer.ListElementClassName := 'pagination';
    tblCustomerUser.Footer.ListItemElementClassName := 'page-item';
    tblCustomerUser.Footer.ListLinkElementClassName := 'page-link';
    tblCustomerUser.Header.ButtonActiveElementClassName := 'btn btn-primary';
    tblCustomerUser.Header.ButtonElementClassName := 'btn btn-light';
    tblCustomerUser.Header.DropDownElementClassName := 'form-control';
    tblCustomerUser.Header.InputElementClassName := 'form-control';
    tblCustomerUser.Header.LinkActiveElementClassName := 'link-primary';
    tblCustomerUser.Header.LinkElementClassName := 'link-secondary';
    tblCustomerUser.Header.ListElementClassName := 'pagination';
    tblCustomerUser.Header.ListItemElementClassName := 'page-item';
    tblCustomerUser.Header.ListLinkElementClassName := 'page-link';
    tblCustomerUser.ParentFont := False;
    tblCustomerUser.WordWrap := True;
    SetEvent(tblCustomerUser, Self, 'OnClickCell', 'tblCustomerUserClickCell');
    tblCustomerUser.ColCount := 3;
  finally
    divCustomerSelectOuterContainer.AfterLoadDFMValues;
    divCustomerSelectMainContainer.AfterLoadDFMValues;
    lblDirty.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    btnAccept.AfterLoadDFMValues;
    tblCustomerAll.AfterLoadDFMValues;
    tblCustomerUser.AfterLoadDFMValues;
  end;
end;

end.